<template>
  <v-dialog :value="dialogProp.show" persistent max-width="700">
    <v-card class="elevation-12">
      <v-toolbar dense :dark="$vuetify.theme.dark" color="primary">
        <v-toolbar-title>
          {{ $t(dialogProp.readonly
            ? 'Просмотр позиции шаблона'
            : 'Редактирование позиции шаблона') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-row v-if="!!generalError || isLoading" class="my-0 py-0 mx-1">
        <v-col cols="12">
          <v-progress-linear :active="isLoading" color="loader" indeterminate />
        </v-col>
        <v-col class="mx-1">
          <general-error v-if="!!generalError" />
        </v-col>
      </v-row>
      <v-card-text class="pt-3">
        <position-template-info-fix
            v-if="dialogProp.lotTemplate.premiumType === PREMIUM_TYPES.FIX"
            ref="position"
            :position-info="position"
            :readonly="dialogProp.readonly"
            :validated="updatePosition" />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
            id="cancelConfirmBtn"
            class="ma-1"
            color="primary"
            @click="cancel">
          {{ $t(dialogProp.readonly
            ? 'Закрыть'
            : 'Отмена') }}
        </v-btn>
        <v-btn
            v-if="!dialogProp.readonly"
            id="continueOperationBtn"
            class="ma-1"
            color="primary"
            :disabled="isLoading"
            @click.stop="continueOperation">
          {{ $t('Продолжить') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import PositionTemplateInfoFix from '@/components/pages/shared/LotTemplate/PositionTemplate/PositionTemplateInfoFix.vue'
  import GeneralError from '@/components/reused/common/GeneralError.vue'
  import { PREMIUM_TYPES } from '@/constants/business'
  import { POSITIONS_TEMPLATE_MANAGEMENT } from '@/constants/store'
  import { mapActions, mapState } from 'vuex'

  export default {
    components: {
      GeneralError,
      PositionTemplateInfoFix
    },
    props: {
      dialogProp: {
        type: Object,
        default: () => {
          return {
            lotTemplate: {
              lotTemplateId: null,
              premiumType: null
            },
            positionTemplateId: null,
            readonly: false,
            show: false,
            callback: null
          }
        }
      }
    },
    data () {
      return {
        PREMIUM_TYPES,
        isLoading: false
      }
    },
    computed: {
      ...mapState(POSITIONS_TEMPLATE_MANAGEMENT.NAMESPACE, {
        position: state => (state[POSITIONS_TEMPLATE_MANAGEMENT.STATE.CURRENT_POSITION_TEMPLATE] || {})
      })
    },
    created () {
      this.clearStore().then(() => {
        if (!this.dialogProp.lotTemplate.premiumType ||
          !this.dialogProp.lotTemplate.lotTemplateId ||
          !this.dialogProp.positionTemplateId) {
          this.showErrorAction({
            message: this.$t('Данные для изменения позиции указаны некорректно.')
          })
          return
        }
        this.getPositionInfo()
      })
    },
    methods: {
      ...mapActions(POSITIONS_TEMPLATE_MANAGEMENT.NAMESPACE, {
        getPositionInfoAction: POSITIONS_TEMPLATE_MANAGEMENT.ACTIONS.GET_POSITION_TEMPLATE_INFO,
        updatePositionAction: POSITIONS_TEMPLATE_MANAGEMENT.ACTIONS.UPDATE_POSITION_TEMPLATE,
        clearPositionInfoAction: POSITIONS_TEMPLATE_MANAGEMENT.ACTIONS.CLEAR_POSITION_TEMPLATE_INFO
      }),
      clearStore: async function () {
        return Promise.all(
          [
            this.hideErrorAction(),
            this.clearPositionInfoAction()
          ])
      },
      continueOperation: async function () {
        try {
          this.isLoading = true
          await this.$refs.position.validate()
          if (this.dialogProp.callback) {
            await this.dialogProp.callback()
            this.isLoading = false
            this.cancel()
          }
        } catch (error) {
          this.isLoading = false
          this.throwIfUnknownError(error)
        }
      },
      getPositionInfo: async function () {
        try {
          this.isLoading = true
          await this.getPositionInfoAction({
            lotTemplateId: this.dialogProp.lotTemplate.lotTemplateId,
            lotType: this.dialogProp.lotTemplate.lotType,
            premiumType: this.dialogProp.lotTemplate.premiumType,
            positionTemplateId: this.dialogProp.positionTemplateId
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false
          this.throwIfNotServerError(error)
        }
      },
      updatePosition: async function (position) {
        await this.updatePositionAction({
          lotTemplateId: this.dialogProp.lotTemplate.lotTemplateId,
          lotType: this.dialogProp.lotTemplate.lotType,
          premiumType: this.dialogProp.lotTemplate.premiumType,
          positionTemplateId: this.dialogProp.positionTemplateId,
          position
        })
      },
      cancel: function () {
        this.$emit('close')
      }
    }
  }
</script>
